import React, { createContext, useContext, useState, useEffect } from 'react';

const AppSettingsContext = createContext();

// Super User emails
const SUPER_USER_EMAILS = [
  'techscriptaid@gmail.com',
];

const DEFAULT_SETTINGS = {
  hideRegistration: false,
  maintenanceMode: false,
  maintenanceMessage: 'VoiceMeet Pro is under maintenance. Please try again later.',
  allowRecording: true,
  showDebugInfo: false,
  betaFeatures: true,
  maxParticipants: 50,
  maxRecordingMinutes: 120,
  allowGuestJoin: true,
  requireWaitingRoom: true,
};

export const AppSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    // Load from localStorage on init
    const saved = localStorage.getItem('voicemeet_app_settings');
    return saved ? JSON.parse(saved) : DEFAULT_SETTINGS;
  });

  // Save to localStorage whenever settings change
  useEffect(() => {
    localStorage.setItem('voicemeet_app_settings', JSON.stringify(settings));
  }, [settings]);

  const updateSetting = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetSettings = () => {
    setSettings(DEFAULT_SETTINGS);
    localStorage.removeItem('voicemeet_app_settings');
  };

  const isSuperUser = (email) => {
    return SUPER_USER_EMAILS.includes(email?.toLowerCase());
  };

  return (
    <AppSettingsContext.Provider value={{ 
      settings, 
      updateSetting, 
      resetSettings,
      isSuperUser,
      SUPER_USER_EMAILS
    }}>
      {children}
    </AppSettingsContext.Provider>
  );
};

export const useAppSettings = () => {
  const context = useContext(AppSettingsContext);
  if (!context) {
    throw new Error('useAppSettings must be used within AppSettingsProvider');
  }
  return context;
};